// Schemas
import { schema } from 'normalizr'

// Types
import { QueryResult } from 'types'

export type CollectionsState = {
  [queryString: string]: QueryResult
}

export type Loop = {
  id?: number
  track_id?: number
  beat_start: number
  beat_count: number
  time_start?: number
  time_end?: number
}

export type Collection = {
  readonly id: number
  readonly covers: Array<string>
  readonly crate: string
  readonly description: string
  readonly owner: number
  readonly owner_avatar: string
  readonly ownergroups: Array<string>
  readonly owner_name: string
  readonly public: boolean
  readonly title: string
  readonly loop_collection: boolean
  readonly tracks: Array<{
    id: number
    loop?: Loop
  }>
  readonly tags: Array<{
    id: number
    name: string
    slug: string
  }>
}

export const collectionSchema = new schema.Entity('collections')
export const collectionListSchema = [collectionSchema]
